import { GetWpsTransactionInfoResponse } from 'api/laborerPortalAPI/wps'
import { CallAPIAction, Status } from 'api/types'
import { convertTransactionFromResponse, getEmptyTransaction, Transaction } from 'common/utils/wpsConvertResponse'
import Actions from 'redux/actions'

type State = {
  data: Transaction
} & Status

const initialState: State = {
  data: getEmptyTransaction(),
  isLoading: false,
  success: false,
  fail: false,
}

export default (
  state: State = initialState,
  action: CallAPIAction<
    Actions.LABORER_GET_WPS_TRANSACTION_INFO_ASYNC,
    Actions.LABORER_GET_WPS_TRANSACTION_INFO_SUCCESS,
    Actions.LABORER_GET_WPS_TRANSACTION_INFO_FAIL,
    GetWpsTransactionInfoResponse
  >,
) => {
  switch (action.type) {
    case Actions.LABORER_GET_WPS_TRANSACTION_INFO_FAIL:
    case Actions.LABORER_GET_WPS_TRANSACTION_INFO_ASYNC:
      return {
        ...state,
        ...action.status,
      }
    case Actions.LABORER_GET_WPS_TRANSACTION_INFO_SUCCESS: {
      const request = [action.payload].map(convertTransactionFromResponse)

      return {
        ...state,
        ...action.status,
        data: request[0],
      }
    }

    default:
      return state
  }
}
